import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/modules/f8/hooks';
import { appRoutes } from './routes'

const auth = useAuth();
const userPerms = auth.getCurrentUserData()?.permissions || [];

const userHasPerm = (perm) => {
  if (!perm) return true; // If no permission is required, allow access
  return userPerms.includes(perm);
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [],
})

const undefinedViewComponent = () => import('@/modules/f8/views/RouteUndefinedView.vue');
const accessDeniedViewComponent = () => import('@/modules/f8/views/RouteAccessDeniedView.vue');

for (let i = 0; i < appRoutes.length; i++) {
  let route = appRoutes[i];
  router.addRoute({
    path: route.path,
    name: route.name,
    meta: route.meta,
    component: userHasPerm(route.meta?.perm)
      ? route.component ?? undefinedViewComponent
      : accessDeniedViewComponent,
    beforeEnter: route.beforeEnter
  });

  // If the route has sublinks, add them as well
  route.meta.sublinks?.forEach(sublink => {
    router.addRoute({
      path: sublink.path,
      name: sublink.name,
      meta: sublink.meta,
      component: userHasPerm(sublink.meta?.perm)
        ? sublink.component ?? undefinedViewComponent
        : accessDeniedViewComponent,
      beforeEnter: sublink.beforeEnter,
    });
  });
}

// set window title
router.afterEach((to) => {
  let route = appRoutes.find(r => r.path === to.path);
  if (route && route.name) {
    document.title = route.meta.label + ' | F8 2.1';
  }
});

if (!auth.getCurrentUserData()) {
  router.push('/login?m=XM014');
}

if (!auth.refreshAccessToken()) {
  router.push('/login?m=XM015');
}

// check if user is logged in to access route
router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.unauthorized)) {
    next(); return;
  }

  if (!auth.getCurrentUserData()) {
    next('/login?m=XM016'); return;
  }

  next();
});



export default router
